import React from 'react';
import { openInNewTab } from '../../../utils/utils';
import Button from './Button';

const LinkButton = ({ color, text, icon, className, href, ...props }) => {

  return (
    <Button
      onClick={() => openInNewTab(href)}
      color={"#6C52E3"}
      text={text}
      className={className}
      {...props}
    />
  );
};

export default LinkButton;

